import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import _ from "lodash";
import { Form, Formik, FormikValues } from "formik";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  EC_SUBMISSION_TYPES,
  RoutingList,
} from "../../../../constants";
import { useCreateEcsMutation } from "../../../../generated/graphql";
import { formikMultiStepHandler } from "../../../../utils/formikMultiStepFormStepHandler";
import { logger } from "../../../../utils/logger";
import CreatePageFormFooter from "../../../common/Form/CreatePageFormFooter/CreatePageFormFooter";
import ProgressSteps from "../../../common/ProgressSteps/ProgressSteps";
import ECSubmissionPVPD from "../ECSubmission/ECSubmissionPVPD";
import StudyDetailsPvpd from "../StudyDetails/StudyDetailsPvpd";
import { PvpdInitData, PvpdStudyDetailsValidation } from "../utils";
import { DocumentSubmissionDropdown } from "../../../../types/forms/DoumentSubmission";

type IRProps = {};

const PV_PD_stepsInfo = ["1. Study Details", "2. EC Notification"];


const PvpdDetails = (props: IRProps) => {
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();
  const [createEcsMutation] = useCreateEcsMutation();
  const saveHandler = async (values: FormikValues) => {
    try {
      await createEcsMutation({
        variables: {
          department: values.department,
          emails: values.emails,
          isFunded: values.isFunded,
          fundType: values.fundType,
          micr: values.micr,
          principalInvestigator: values.principalInvestigator,
          coInvestigator: values.coInvestigator,
          protocolNumber: values.protocolNumber,
          sponsor: values.sponsor,
          studyPhase: values.studyPhase,
          title: values.title,
          dateOfEvent: values.dateOfEvent,
          typeOfPVPD: values.typeOfPvPd,
          typeOfStudy: values.typeOfStudy,
          documents: values.documents
            .filter((doc: DocumentSubmissionDropdown) => doc.url !== "")
            .map((doc: DocumentSubmissionDropdown ) => ({
              label: doc.dropdownSelectedValue ? doc.label + '(' + doc.dropdownSelectedValue + ')' : doc.label,
              url: doc.url,
              remark: doc.remark,
              // dropdownSelectedValue: doc.dropdownSelectedValue|| ''
            })),
          type: EC_SUBMISSION_TYPES.PVPD_DETAILS,
        },
      });
      toast.success("PV/PD EC notifications created successfully!");
      navigate(RoutingList.ethics_committee.index.path);
    } catch (err) {
      toast.error((err as { message: string }).message);
      logger.error(err);
    }
  };

  return (
    <Formik
      initialValues={_.cloneDeep(PvpdInitData)}
      enableReinitialize={true}
      validationSchema={PvpdStudyDetailsValidation[currentStep]}
      onSubmit={(values, { setSubmitting, setErrors, validateForm }) => {
        formikMultiStepHandler({
          validateForm,
          values,
          stepIndex:
            currentStep > PV_PD_stepsInfo.length - 1 ? currentStep : currentStep + 1,
          setErrors,
          steps: currentStep,
          stepsInfo: PV_PD_stepsInfo,
          setSteps: setCurrentStep,
          saveHandler,
        });
      }}
    >
      <Form>
        <Card>
          <CardContent className="pd-x-30 pd-y-30">
            <Box className="mg-b-40">
              <Typography className="mg-b-10" variant="h2" component="h2">
                PV/PD EC notifications
              </Typography>
              <ProgressSteps stepsInfo={PV_PD_stepsInfo} currentStep={currentStep} />
            </Box>
            <Grid container className="justify-content-center">
              <Grid item xs={12} md={10} lg={10}>
                {currentStep === 0 && <StudyDetailsPvpd />}
                {currentStep === 1 && <ECSubmissionPVPD />}
                <CreatePageFormFooter
                  setSteps={setCurrentStep}
                  steps={currentStep}
                  stepsInfo={PV_PD_stepsInfo}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Form>
    </Formik>
  );
};

export default PvpdDetails;
